import './site.css'
import { mountNav, toast } from './nav'
import { api, short, fmt } from './api'
import { getWallet } from './wallet'

mountNav('profile')
const root = document.getElementById('root')!

async function render() {
  const q = new URLSearchParams(location.search)
  const me = getWallet()
  const wallet = q.get('wallet') || me
  if (!wallet) {
    root.innerHTML = `<h2>Profile</h2><p>Connect a wallet (top right) to see your profile, or open someone's with <code>?wallet=…</code>.</p>`
    return
  }
  const own = wallet === me
  let p: any
  try { p = await api(`/api/profile/${wallet}`) } catch (e: any) { root.innerHTML = `<p class="muted">${e.message}</p>`; return }
  const r = p.rights || { tier: 0, quota: 0, balance: 0, used: 0 }
  root.innerHTML = `
    <h2>${p.name || short(wallet)} ${p.crew ? `<span class="muted">· $${p.crew}</span>` : ''}</h2>
    <p class="muted mono" style="font-size:12px">${wallet} ${p.online ? '· <span style="color:var(--pump)">in the world now</span>' : ''}</p>
    <div class="stats">
      <div class="stat"><b>${r.tier}</b><span>tier (${fmt(Math.round(r.balance))} $QBLOCK)</span></div>
      <div class="stat"><b>${r.quota}</b><span>blocks / hour</span></div>
      <div class="stat"><b>${fmt(p.placed)}</b><span>blocks placed</span></div>
      <div class="stat"><b>${fmt(p.broken)}</b><span>blocks broken</span></div>
    </div>
    ${own ? `<div class="card" style="margin:16px 0"><h3>Your identity</h3>
      <div class="row"><input class="field" id="name" placeholder="display name" value="${p.name || ''}" maxlength="20" />
      <input class="field" id="crew" placeholder="crew ticker (e.g. BONK)" value="${p.crew || ''}" maxlength="12" />
      <button class="btn small" id="save">save</button></div>
      <p class="muted" style="font-size:13px;margin:8px 0 0">Your crew colours your parcel on the world map. Territory war starts there.</p></div>` : ''}
    <div class="card" style="margin:16px 0"><h3>Parcel</h3>
      ${p.parcel ? `${p.parcel.size}×${p.parcel.size} at <b>${p.parcel.x}, ${p.parcel.z}</b> · <a href="/play.html?x=${p.parcel.x + p.parcel.size / 2}&y=45&z=${p.parcel.z + p.parcel.size / 2}">visit</a> · <a href="/map.html">map</a>
        ${own ? ` · <button class="btn small danger" id="release">release</button>` : ''}` : own ? 'No parcel yet. In the game, stand where you want it and hit <b>claim parcel here</b>.' : 'No parcel.'}
    </div>
    <h3>Captures</h3>
    ${p.captures.length ? `<div class="caps">${p.captures.map((c: any) => `<div class="cap"><a href="/play.html?x=${c.x}&y=${c.y}&z=${c.z}"><img src="${c.image}" alt="" /></a><div class="meta"><span>${c.title || 'untitled'} · ${c.x}, ${c.y}, ${c.z}</span><span class="muted">${new Date(c.ts).toLocaleDateString()}</span></div></div>`).join('')}</div>` : '<p class="muted">No captures yet. Press <b>C</b> in the game.</p>'}
  `
  document.getElementById('save')?.addEventListener('click', async () => {
    try {
      await api('/api/me', { method: 'POST', body: JSON.stringify({ name: (document.getElementById('name') as HTMLInputElement).value, crew: (document.getElementById('crew') as HTMLInputElement).value }) })
      toast('Saved'); render()
    } catch (e: any) { toast(e.message) }
  })
  document.getElementById('release')?.addEventListener('click', async () => {
    if (!confirm('Release your parcel? Anyone will be able to build there.')) return
    try { await api('/api/parcels/release', { method: 'POST', body: '{}' }); toast('Parcel released'); render() } catch (e: any) { toast(e.message) }
  })
}
render()
window.addEventListener('block:auth', render)
